const initialState = {
    isLoading: false,
    userData: null,
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REGISTER_USER":
            return { ...state, isLoading: true };
        case "REGISTER_SUCCESS":
            return { ...state, isLoading: false, userData: action.payload };
        default:
            return state;
    }
};

export default authReducer;
